<script setup lang="ts">
const { isSwitching, impersonatedCustomer } = useImpersonation()

// Determine if this is first selection or a switch
const title = computed(() => {
  const name = impersonatedCustomer.value.customerName
  return `Loading ${name}`
})
</script>

<template>
  <Transition
    enter-active-class="transition-opacity duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity duration-200 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="isSwitching"
      class="absolute inset-0 flex items-center justify-center bg-background/90 backdrop-blur-md"
      style="z-index: 1000;"
    >
      <div class="flex flex-col items-center gap-5">
        <!-- Animated loader -->
        <UIcon
          name="i-svg-spinners:blocks-shuffle-3"
          class="size-8 text-primary"
        />

        <!-- Text -->
        <div class="text-center space-y-1">
          <p class="text-sm font-medium text-default">
            {{ title }}
          </p>
          <p class="text-xs text-muted">
            Loading account data...
          </p>
        </div>
      </div>
    </div>
  </Transition>
</template>
